import "../../IsiControlesNames"
/**
 * Cette classe permet d'accéder aux différents éléments DOM constituant la structure de la page
 **/
export class IsiDomStructure {
    _master: JQuery;
    _divFormulaire: JQuery;
    _divDetail: JQuery;
    _divDetailGrip: JQuery;
    _divEntete: JQuery;
    _divMainContent: JQuery;
    _divBannerGlobal: JQuery;
    _divMenuPrinc: JQuery;


    init() {

        this._divFormulaire = jQuery("#" + DIV_FORMULAIRE);
        this._divDetail = jQuery("#" + DIV_DETAIL);
        this._divDetailGrip = jQuery("#" + DIV_DETAIL_GRIP);
        this._divEntete = jQuery("#" + DIV_ENTETE);
        this._divMainContent = jQuery("#" + DIV_MAINCONTENT);
        this._divBannerGlobal = jQuery("#" + IdDivBannerGlobal);
        this._divMenuPrinc = jQuery("#" + DIV_MENUPRINC);
    }

    get master() {
        return this._master;
    }

    get divDetail() {
        return this._divDetail;
    }

    get divDetailGrip() {
        return this._divDetailGrip;
    }

    get divEntete() {
        return this._divEntete;
    }

    get divMainContent() {
        return this._divMainContent;
    }

    get divFormulaire() {
        return this._divFormulaire;
    }
    get divBannerGlobal() {
        return this._divBannerGlobal;
    }

    get divMenuPrinc() {
        return this._divMenuPrinc;
    }

}